export default __webpack_public_path__ + "locales/fr/EmptyView.json?hash=9fd3922177de5b088e7be9632a2a2af5";